var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoCircleFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 1.667A8.333 8.333 0 1 1 1.667 10 8.333 8.333 0 0 1 10 1.667m-.001 7.231a.98.98 0 0 0-.994.968V13.9c0 .535.445.968.994.968a.98.98 0 0 0 .994-.968V9.866A.98.98 0 0 0 10 8.898m0-4.03a.98.98 0 0 0-.994.966c0 .534.445.968.994.968h.01c.55 0 .995-.434.995-.968s-.445-.967-.994-.967z"
})));
SvgInfoCircleFilled.displayName = "SvgInfoCircleFilled";
export { SvgInfoCircleFilled as ReactComponent };
export default SvgInfoCircleFilled;